import { sizes as sizeOrder } from "./siteValues";

export const normalizePatternSize = (value: string) => value.trim().toLowerCase();

export const formatPatternSizeLabel = (size: string) =>
  size === "onesize" ? "ONE SIZE" : size.toUpperCase();

export const getOrderedPatternSizes = (sizes: string[] = []) => {
  const safeSizes = Array.from(
    new Set(
      (Array.isArray(sizes) ? sizes : [])
        .filter((size): size is string => typeof size === "string")
        .map((size) => normalizePatternSize(size))
        .filter(Boolean)
    )
  );

  const knownSizes = sizeOrder.filter((size) => safeSizes.includes(size));
  const customSizes = safeSizes.filter((size) => !knownSizes.includes(size));

  return [...knownSizes, ...customSizes];
};

type CartItemLike = {
  id: string;
  selectedSize?: string | null;
  sizes?: string[];
};

export const resolveCartSelectedSize = (item: CartItemLike) => {
  const explicitSize =
    typeof item.selectedSize === "string" ? item.selectedSize : "";
  if (explicitSize.trim()) {
    return normalizePatternSize(explicitSize);
  }

  const fallbackSize =
    Array.isArray(item.sizes) && item.sizes.length === 1 ? item.sizes[0] : "";
  return fallbackSize ? normalizePatternSize(fallbackSize) : "";
};

export const getCartItemKey = (item: CartItemLike) =>
  `${item.id}::${resolveCartSelectedSize(item)}`;
